import { makeVar, TypePolicies } from '@apollo/client';
import {
  CapaQuotationUserChatRoomsOutput,
  CapaQuotationUserUnReadMessagesCount
} from '@generated/graphql';

export const unreadCountVar = makeVar<CapaQuotationUserUnReadMessagesCount[]>(
  []
);

const fetchQuotationUserChatRoomsCache: TypePolicies = {
  Query: {
    fields: {
      fetchQuotationUserChatRooms: {
        keyArgs: ['input', ['searchKeyword', 'searchStatusType']],
        merge: (
          exsiting: CapaQuotationUserChatRoomsOutput,
          incoming: CapaQuotationUserChatRoomsOutput,
          {
            args: {
              input: { offset }
            }
          }: any
        ): CapaQuotationUserChatRoomsOutput => {
          if (!exsiting) return incoming;

          unreadCountVar(incoming.data?.totalUnReadMessagesCount ?? []);

          const incomingRfqs = incoming.data?.chatRooms ?? [];
          const merged = exsiting.data?.chatRooms
            ? exsiting.data?.chatRooms.slice(0)
            : [];

          for (let i = 0; i < incomingRfqs.length; ++i) {
            merged[offset + i] = incomingRfqs[i];
          }

          return {
            __typename: 'CAPAQuotationUserChatRoomsOutput',
            ...incoming,
            data: {
              ...incoming.data,
              chatRooms: merged
            }
          };
        }
      }
    }
  }
};

export default fetchQuotationUserChatRoomsCache;
